import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import structuredClone from '@ungap/structured-clone';
import { Subscription, of } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { EngagementService } from 'src/app/care/engagement/engagement.service';
import { ChooseTemplateFlowService } from 'src/app/shared/components/choose-template-flow/shared/choose-template-flow.service';
import { EngagementTemplateFlowStepEnum } from 'src/app/shared/components/choose-template-flow/shared/engagement-template-flow-step.enum';
import { WhatsappTemplate } from 'src/app/task-process/shared/models';

@Component({
  selector: 'app-choose-whatsapp-template',
  templateUrl: './choose-whatsapp-template.component.html',
  styleUrls: [
    '../../../../task-process/answer-editor/answer-editor.component.scss',
    './choose-whatsapp-template.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ChooseWhatsappTemplateComponent implements OnInit, OnDestroy {
  @Input() templates: WhatsappTemplate[] = [];
  searchCtrl = new FormControl('');
  subscriptions: Subscription = new Subscription();
  selected: number = this.chooseTemplateFlowService.selectedTemplate?.id;
  whatsappTemplates: WhatsappTemplate[] = [];
  templatesFiltered = [];
  templatesMap: Map<number, WhatsappTemplate>;

  constructor(
    public engagementService: EngagementService,
    public chooseTemplateFlowService: ChooseTemplateFlowService
  ) {}

  ngOnInit() {
    of(this.templates).subscribe({
      next: (templates = []) => {
        this.whatsappTemplates = templates;
        this.templatesMap = templates.reduce((result, template) => {
          result.set(template.id, template);
          return result;
        }, new Map());
        this.templatesFiltered = this.whatsappTemplates;
        this.subscriptions.add(this.searchCtrl.valueChanges.pipe(debounceTime(300)).subscribe(this.filterTemplates));
      },
    });
  }

  back() {
    this.engagementService.flowStep = EngagementTemplateFlowStepEnum.CHOOSE_RECIPIENT_SENDER;
  }

  private filterTemplates = (value: string) => {
    if (!value) {
      this.templatesFiltered = this.whatsappTemplates;
    } else {
      this.templatesFiltered = this.whatsappTemplates.filter(({ name, textWithReplacedPlaceholders }) =>
        new RegExp(value, 'gi').test(`${name}#${textWithReplacedPlaceholders}`)
      );
    }
  };

  composeTheMessage(): void {
    const selectedTemplate = structuredClone(this.templatesMap.get(this.selected));
    const hasMediaHeader = selectedTemplate.header?.type === 'media';
    const hasPlaceholders = (Object.keys(selectedTemplate.placeholders || {}) || []).length > 0;
    const hasButtons = (selectedTemplate.buttons || []).length > 0;
    const hasParameters = hasMediaHeader || hasPlaceholders || hasButtons;
    this.chooseTemplateFlowService.selectedTemplate = selectedTemplate;
    this.chooseTemplateFlowService.hasParameters = hasParameters;

    if (!hasParameters) {
      this.chooseTemplateFlowService.isValid = true;
      this.engagementService.flowStep = EngagementTemplateFlowStepEnum.PREVIEW_AND_SEND_MESSAGE;
    } else {
      this.engagementService.flowStep = EngagementTemplateFlowStepEnum.COMPOSE_MESSAGE;
    }
  }

  /**
   * Allows to clear the search filter.
   */
  clearSearch() {
    this.searchCtrl.reset();
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
